/* ハンバーガーメニュー
========================================================*/
import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initHeaderFunctions() {
    const menu = document.querySelectorAll('.header__nav__inner');
    const openBtn = document.querySelectorAll('.openbtn');
    const mqPc = window.matchMedia(MEDIA_QUERIES.pc);
    

    (function(){
        let hamburgerMenu = $(".js-hamburgerMenu");
        let headerNav = $(".header__nav");
        
        hamburgerMenu.on("click", function(){
            if (mqPc.matches) return;
            $(this).toggleClass("is-active");  
            headerNav.toggleClass("is-spOpen");
        });

        mqPc.addEventListener("change", function(){
            if (mqPc.matches) {
                hamburgerMenu.removeClass("is-active");
                headerNav.removeClass("is-spOpen");
            }
        });
    })();

    (function(){
        let header = $(".header");
        let headerNav = $(".header__nav");
        let lastScrollTop = 0;
        let delta = 5;
        let headerHeight = header.outerHeight();

        $(window).on("scroll", function() {
            let st = $(this).scrollTop();

            if(Math.abs(lastScrollTop - st) <= delta)
                return;

            if (st > lastScrollTop && st > headerHeight){
                if (!headerNav.hasClass("is-spOpen")) {
                    header.addClass("is-hidden");
                }
            } else {
                if(st + $(window).height() < $(document).height()) {
                    header.removeClass("is-hidden");
                }
            }

            lastScrollTop = st;
        });
    })();

    (function(){
        let currentPath = window.location.pathname;
        let navLinks = $(".header__nav__link .navLink");
        
        navLinks.each(function() {
            let href = $(this).children("a").attr("href") || $(this).data("navHref");
            if (href) {
                if (href === "/") {
                    if (currentPath === "/" || currentPath === "/index.php") {
                        $(this).addClass("is-current");
                    }
                } else if (currentPath.startsWith(href)) {
                    $(this).addClass("is-current");
                }
            }
        });
    })();

    (function(){
        const navLinksWithSub = $(".header__nav__link .navLink").filter(function() {
            return $(this).children(".navLink__sub").length > 0;
        });

        function toMobileToggle() {
            navLinksWithSub.each(function() {
                const $navLink = $(this);
                const $anchor = $navLink.children("a").first();
                if (!$anchor.length) return;

                $navLink.data("navHref", $anchor.attr("href"));

                const $toggle = $("<span>", {
                    class: "js-headerNavLinkToggle",
                    role: "button",
                    tabindex: "0",
                });
                $toggle.append($anchor.contents());
                $anchor.replaceWith($toggle);

                $navLink.children(".navLink__sub").hide();
                $navLink.removeClass("is-active");
            });
        }

        function toDesktopLink() {
            navLinksWithSub.each(function() {
                const $navLink = $(this);
                const $toggle = $navLink.children(".js-headerNavLinkToggle").first();
                if (!$toggle.length) return;

                const $anchor = $("<a>", { href: $navLink.data("navHref") });
                $anchor.append($toggle.contents());
                $toggle.replaceWith($anchor);

                $navLink.children(".navLink__sub").css("display", "");
                $navLink.removeClass("is-active");
            });
        }

        function updateNavLinkMode() {
            if (mqPc.matches) {
                toDesktopLink();
            } else {
                toMobileToggle();
            }
        }

        navLinksWithSub.on("click", ".js-headerNavLinkToggle", function() {
            if (mqPc.matches) return;

            const $navLink = $(this).closest(".navLink");
            const $subMenu = $navLink.children(".navLink__sub");

            $navLink.toggleClass("is-active");
            $subMenu.stop(true, false).slideToggle(300);
        });

        updateNavLinkMode();
        mqPc.addEventListener("change", updateNavLinkMode);
    })();
}
